import { inject } from "vue";
import type { INewConsignmentService } from "./types";

declare global {
  const $newConsignment: INewConsignmentService;
}

/**
 * A unique identifier to access the provided/injected method
 */
export const NewConsignmentSymbol = Symbol();

/**
 * Composable which allows accessing the NewConsignment service in Composition API
 * @returns NewConsignment
 */
export function useNewConsignment() {
  const NewConsignment = inject(NewConsignmentSymbol);
  if (!NewConsignment) {
    throw new Error("No NewConsignment provided!");
  }

  return NewConsignment;
}

/**
 * Vue app install. Global property for Options API and provided service for Composition API
 */
export const NewConsignmentService = {
  install: (app) => {
    const NewConsignmentService: INewConsignmentService = {
      open: () => {
        EventBus.$emit("NEW_CONSIGNMENT_OPEN");
      },
      close: () => {
        EventBus.$emit("NEW_CONSIGNMENT_CLOSE");
      },
    };
    app.config.globalProperties.$NewConsignment = NewConsignmentService;
    if (typeof window !== "undefined") window.$newConsignment = NewConsignmentService;
    app.provide(NewConsignmentSymbol, NewConsignmentService);
  },
};
